// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1H2Mm","footer":"styles_footer__3afin","passCodeTooltip":"styles_passCodeTooltip__2qrKr"};